import regEx from '../config/regex';

import { useWindowWidth } from "@react-hook/window-size";
import { store } from "../store";

export const CurrentLayoutWidth = () => {
  const width = useWindowWidth();

  if (width) {
    switch (true) {
      case width < 640:
        return "xs";
      case width >= 640 && width < 768:
        return "sm";
      case width >= 768 && width < 1024:
        return "md";
      case width >= 1024 && width < 1280:
        return "lg";
      case width >= 1280 && width < 1500:
        return "xl";
      case width >= 1500:
        return "xxl";
      default:
        return "xxl";
    }
  } else {
    return "xxl";
  }
};
/*
 * This Function is used for Updating Childrens
 */
export function addChildrensToMapData(mapData: any, items: any, key: string) {
  let result = mapData.find((node: any) => {
    return node.name === key;
  });
  if (result) {
    result.childrens = items;
  }
  return mapData;
}
/*
 * This Function is used for Updating Childrens
 */
export function addChildrensToMapDataByIndex(
  mapData: any,
  items: any,
  key: string,
  index: number
) {
  let result = mapData[index].find((node: any) => {
    return node.name === key;
  });
  if (result) {
    result.childrens = items;
  }
  return mapData;
}
/*
 * This Function is used for Updating Childrens
 */
export function appendChildrensToMapData(
  mapData: any,
  items: any,
  key: string
) {
  let result = mapData.find((node: any) => node.name === key);
  if (result) {
    result.childrens.push(...items);
  }
  return mapData;
}

export function updateObjectKeyValue(
  mapData: any,
  objectKey: string,
  key: string,
  value: any
) {
  const data = mapData.find((node: any) => {
    return node.name === objectKey;
  });
  if (data) {
    data[key] = value;
  }
  return mapData;
}

export function appendLoopDataToMapData(mapData: any, items: any) {
  let result: any = [];
  items.forEach((item: any) => {
    let copy = JSON.parse(JSON.stringify(mapData));
    copy.forEach((node: any) => {
      Object.keys(item).forEach((key) => {
        if (node.name === key) {
          node.value = key === "id" ? [item[key]] : item[key];
          node.error = false;
          node.disabled = false;
        }
      });
    });
    result.push(copy);
  });
  return result;
}

export function actualDataToMapData(mapData: any, item: any) {
  console.log("mapdata", mapData, item);
  mapData.forEach((node: any) => {
    const exp = node.name ? node?.name.split(".") : "";
    Object.keys(item).forEach((key) => {
      if (node.name === key) {
        node.value =
          node.name === "fallthrough"
            ? [item[key]]
            : item[key] !== null
              ? item[key]
              : "";
        node.error = false;
        node.disabled = false;
      } else if (node.type === "password") {
        node.showHint = false;
      } else if (exp.length === 2 && exp[0] === key) {
        node.value = item[exp[0]][exp[1]];
      } else if (exp.length === 3 && exp[0] === key) {
        node.value = item[exp[0]][exp[1]][exp[2]];
      }
      if (node?.reference && node?.reference?.items) {
        node?.reference?.items.forEach((ref: any) => {
          let refData = mapData.find((refMap: any) => {
            return refMap.name === ref;
          });
          if (refData) {
            if (node.reference.condition.operator === "=") {
              refData[node.reference.action] = node.value;
            } else if (node.reference.condition.operator === "!=") {
              refData[node.reference.action] = !node.value;
            }
          }
        });
      }
    });
  });

  mapData.forEach((node: any) => {
    if (node.reference) {
      let refData: any = mapData.find((n: any) => {
        return n.name === node?.reference.name;
      });
      if (refData) {
        if (node.reference.condition.operator === "=") {
          refData[node.reference.action] = node.value;
        }
      }
    }
  });
  console.log("mapData", mapData);
  return mapData;
}
export function addAKeyValueInListItems(mapData: any, key: string, value: any) {
  mapData.forEach((node: any) => {
    node[key] = node[value] ? node[value] : value;
  });
  return mapData;
}
export function addAKeyValueFromRefListItems(
  mapData: any,
  key: string,
  ref: any
) {
  mapData.forEach((node: any) => {
    node[key] = node[ref[0]] + " " + (ref[1] ? node[ref[1]] : "");
  });
  return mapData;
}

export function secondsToHms(d: any) {
  d = Number(d);
  const h = Math.floor(d / 3600)
    .toString()
    .padStart(2, "0"),
    m = Math.floor((d % 3600) / 60)
      .toString()
      .padStart(2, "0"),
    s = Math.floor(d % 60)
      .toString()
      .padStart(2, "0");
  let adjust = "";
  if (h === "00") {
    if (m === "00") {
      adjust = `0:${s}`;
    } else {
      adjust = `${m}:${s}`;
    }
  } else {
    adjust = `${h}:${m}:${s}`;
  }

  // return h + ':' + m + ':' + s;
  return adjust;
}
export function randomNumber() {
  let array = new Uint32Array(1);
  window.crypto.getRandomValues(array);
  return array[0];
}
export function formValidation(dummy: any) {
  let ObjectData: any = {};
  let valiState = true;
  let msg = "";
  dummy.forEach((node: any) => {
    let regExTest = false;
    // debugger
    if (node?.regEx) {
      let res = node.regEx;
      regExTest = !res.test(node.value);
    } else {
      if (node?.type === "password") {
        let res = regEx.password;
        regExTest = !res.test(node.value);

      } else if (node?.type === "email") {
        let res = regEx.email;
        regExTest = !res.test(node.value);
      }
    }
    if (
      node.required === true &&
      node?.value?.length < node?.minLength &&
      (node.value !== "" ||
        regExTest ||
        (Array.isArray(node.value) && node.value.length !== 0)) &&
      (!node.hidden || node.hidden === false) &&
      (!node?.disabled || node.disabled === false)
    ) {
      if (valiState) {
        msg = `Minimum ${node?.minLength} Characters Required`;
        valiState = false;
        node.error = true;
      }
    }

    if (
      node.required === true &&
      (node.value === null || node.value === "" ||
        regExTest ||
        (Array.isArray(node.value) && node.value.length === 0)) &&
      (!node.hidden || node.hidden === false) &&
      (!node?.disabled || node.disabled === false)
    ) {

      if (valiState) {
        msg = msg + " " + node?.errormessage ? node.errormessage : node.title;

      }

      if (node.type === "password" && regExTest) {
        node.showHint = true;
      }
      valiState = false;
      node.error = true;
    } else {
      node.error = false;
    }

    if (node?.result?.key && Array.isArray(node.value)) {
      let val: any = [];
      node.value.forEach((n: any) => {
        if (n[node?.result.key]) {
          val.push(n[node?.result.key]);
        } else {
          val.push(n);
        }
      });
      ObjectData[node.name] = val;
    } else if (node?.result?.key && node.value[node?.result?.key]) {
      ObjectData[node.name] = node.value[node?.result?.key];
    } else if (node?.displayProps?.value && Array.isArray(node.value)) {
      let val: any = [];
      node.value.forEach((n: any) => {
        if (n[node?.displayProps?.value]) {
          val.push(n[node?.displayProps?.value]);
        } else {
          val.push(n);
        }
      });
      ObjectData[node.name] = val;
    } else if (node?.displayProps?.value && node.value && node.value[node?.displayProps?.value]) {
      ObjectData[node.name] = node.value[node?.displayProps?.value];
    } else if (node.format === "object") {
      if (node.formatName in ObjectData) {
        let name = node.name
        ObjectData[node.formatName] = {
          ...ObjectData[node.formatName],
          [name]: node.value
        }
      } else {
        let name = node.name
        ObjectData[node.formatName] = {

          [name]: node.value
        }
      }
    }
    else {
      ObjectData[node.name] = node.value;
    }
  })
  return {
    valiState,
    msg,
    ObjectData,
    dummy
  }
}

export function generateRandomNumber(maxLimit = 5) {
  let rand = Math.random() * maxLimit;
  rand = Math.floor(rand);
  return rand;
}

export function changeLayout(
  layouts: any,
  multiSelectDropDown: any,
  layoutData: any,
  setLayouts: any
) {
  console.log("hanldevalues", layouts, layoutData);
  const updatedLayouts = { ...layouts };
  const selectedOptions = multiSelectDropDown[0]?.options || [];
  const selectedLayoutIds = selectedOptions.map((item: any) => item.id);
  const selectedValues = selectedOptions.reduce((acc: any, item: any) => {
    acc[item.id] = item.value;
    return acc;
  }, {});

  Object.keys(updatedLayouts).forEach((layoutSize: any) => {
    const layout = updatedLayouts[layoutSize];
    const newLayout: any[] = [];

    layout.forEach((item: any) => {
      const layoutId = item.i;
      if (selectedLayoutIds.includes(layoutId)) {
        if (selectedValues[layoutId]) {
          newLayout.push(layoutData[layoutSize][layoutId]);
        }
      } else {
        newLayout.push(item);
      }
    });

    selectedLayoutIds.forEach((layoutId: any) => {
      if (
        !layout.find((item: any) => item.i === layoutId) &&
        selectedValues[layoutId]
      ) {
        newLayout.push(layoutData[layoutSize][layoutId]);
      }
    });

    updatedLayouts[layoutSize] = newLayout;
  });
  console.log("updatedLayouts", updatedLayouts);
  setLayouts({ ...updatedLayouts });
}

export function isSuccessCode(
  statusCode: number,
  successDigit: number = 2
): boolean {
  return String(statusCode).startsWith(String(successDigit));
}

export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function trimAndLowercase(str: string) {
  return str.trim().toLowerCase();
}

// FOR REPORTS //

export function dateToEpoch(date: Date) {
  return Math.floor(date.getTime() / 1000);
}

// export const getEpochTimeFromNow = () => {
//   let endDate = new Date();
//   const timeInterval = store?.getState()?.SupervisorReports?.timeInterval;
//   switch (timeInterval) {
//     case "month":
//       endDate = new Date(endDate.setMonth(endDate.getMonth() - 12));
//       break;
//     case "day":
//       endDate = new Date(endDate.setDate(endDate.getDate() - 12));
//       break;
//     case "hour":
//       endDate = new Date(endDate.setHours(endDate.getHours() - 12));
//       break;
//     case "week":
//       endDate = new Date(endDate.setDate(endDate.getDate() - 84));
//       break;
//     default:
//       break;
//   }
//   return dateToEpoch(endDate);
// };

export const daysOfWeek = {
  0: "Sunday",
  1: "Monday",
  2: "Tuesday",
  3: "Wednesday",
  4: "Thursday",
  5: "Friday",
  6: "Saturday",
};

export const monthsOfYear = {
  0: "January",
  1: "February",
  2: "March",
  3: "April",
  4: "May",
  5: "June",
  6: "July",
  7: "August",
  8: "September",
  9: "October",
  10: "November",
  11: "December",
};
